import { ProductSetStatus } from './productSet'

const EndPoints = {
  PortalsBusinessProfile: (portalId: number): string =>
    `portals/${portalId}/businessProfiles`,
  ProductSetTemplates: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productSetTemplates`,
  ProductSetTemplateById: (
    businessProfileId: number,
    templateId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productSetTemplates/${templateId}`,
  ProductSets: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productSets`,
  ProductSetById: (businessProfileId: number, productSetId: number): string =>
    `businessProfiles/${businessProfileId}/productSets/${productSetId}`,
  ProductSetInsights: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productSets/insights`,
  Currencies: () => '/currencies',
  BusinessProfileCurrency: (businessProfileId: number, currencyId: number) =>
    `/businessProfiles/${businessProfileId}/currencies/${currencyId}`,
  PortalUserBusinessProfiles: (
    portalId: number | undefined,
    userId: number | undefined
  ): string => `portals/${portalId}/users/${userId}/businessProfiles`,
  GetDIYDashboards: (businessProfileId: number | undefined): string =>
    `businessProfiles/${businessProfileId}/dashboards`,
  GetMetabaseDashboardKey: (metabaseDashboardId: number | undefined): string =>
    `metabase/${metabaseDashboardId}`,
  AccountDetails: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/accounts`,
  SegmentBusinessProfileSearchEngineMapping: (
    businessProfileId: number,
    segmentId: number
  ): string =>
    `businessProfiles/${businessProfileId}/segments/${segmentId}/Accounts`,
  SearchEngineAuthDetails: (
    businessProfileId: number,
    accountId: number
  ): string =>
    `businessProfiles/${businessProfileId}/accounts/${accountId}/SearchEngineAuth`,
  CustomerSegments: (businessProfileId: number, accountId: number): string =>
    `businessProfiles/${businessProfileId}/accounts/${accountId}/live/customerSegments`,
  CustomerSegmentTemplates: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/segmentTemplates`,
  CustomerSegmentTemplateInsights: (
    businessProfileId: number,
    segmentTemplateId: number
  ): string =>
    `businessProfiles/${businessProfileId}/segmentTemplates/${segmentTemplateId}/insights`,
  GetEmbedAccessToken: (businessProfileId: number, accountId: number): string =>
    `businessProfiles/${businessProfileId}/accounts/${accountId}/embedToken`,
  DeleteSegment: (businessProfileId: number, segmentId: number): string =>
    `businessProfiles/${businessProfileId}/segments/${segmentId}`,
  GetPaginatedCatalogs: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs`,
  GetProductFeeds: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productFeeds`,
  GetCatalogById: (businessProfileId: number, catalogId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}`,
  LabelTypes: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/labelTypes`,
  Labels: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/labels`,
  CreateCatalog: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs`,
  UpdateCatalog: (businessProfileId: number, id: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${id}`,
  GetFilteredProductVariants: (
    businessProfileId: number,
    catalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/productVariants`,
  downloadProductVariants: (
    businessProfileId: number,
    catalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/productVariants/download`,
  ProductEnrichment: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/Roimatic/Products/EnrichContent`,
  RoimaticConfiguration: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic`,
  Products: (businessProfileId: number, productCatalogId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/products`,
  ProductCatalogAudit: (businessProfileId: number, productCatalogId: number) =>
    `BusinessProfiles/${businessProfileId}/ProductCatalogs/${productCatalogId}/Audits`,
  ProductCatalogAuditDetails: (
    businessProfileId: number,
    catalogId: number,
    auditId: number
  ): string =>
    `BusinessProfiles/${businessProfileId}/ProductCatalogs/${catalogId}/Audits/${auditId}/Details`,
  ProductAuditDetails: (
    businessProfileId: number,
    catalogId: number,
    auditId: number
  ): string =>
    `businessProfiles/${businessProfileId}/ProductCatalogs/${catalogId}/Audits/${auditId}/productAuditDetails`,
  BulkPatchProductAuditDetails: (
    businessProfileId: number,
    productCatalogId: number,
    auditId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/audits/${auditId}/productAuditDetails/bulk-patch`,
  ProductAuditDetailsDownload: (
    businessProfileId: number,
    catalogId: number,
    auditId: number
  ): string =>
    `businessProfiles/${businessProfileId}/ProductCatalogs/${catalogId}/Audits/${auditId}/productAuditDetails/Download`,
  BatchUpdateProductCatalogAuditDetails: (
    businessProfileId: number,
    catalogId: number,
    auditId: number
  ) =>
    `BusinessProfiles/${businessProfileId}/ProductCatalogs/${catalogId}/Audits/${auditId}/Details/BulkUpdate`,
  ProductParameters: (businessProfileId: number) =>
    `businessProfiles/${businessProfileId}/productParameters`,
  GetAttributeValues: (businessProfileId: number, catalogId: number) =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/attributeValues`,
  EnrichmentTemplates: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/enrichmentTemplates`,
  UpdateFeed: (businessProfileId: number, id: number): string =>
    `businessProfiles/${businessProfileId}/ProductFeeds/${id}`,
  setCustomLabelTypes: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/customLabelTypes`,
  GetAuditInsights: (
    businessProfileId: number,
    productCatalogId: number,
    auditId?: number,
    isLatest: boolean = false
  ) => {
    const basePath = `BusinessProfiles/${businessProfileId}/ProductCatalogs/${productCatalogId}/Audits`
    if (isLatest) {
      return `${basePath}/Insights?isLatest=true`
    } else if (auditId !== undefined) {
      return `${basePath}/${auditId}/Insights`
    } else {
      throw new Error(
        'Either auditId must be provided or isLatest must be true'
      )
    }
  },
  GetExportAuditInsights: (
    businessProfileId: number,
    productCatalogId: number,
    auditId?: number,
    isLatest: boolean = false
  ) => {
    const basePath = `BusinessProfiles/${businessProfileId}/ProductCatalogs/${productCatalogId}/Audits`
    if (isLatest) {
      return `${basePath}/ExportInsights?isLatest=true`
    } else if (auditId !== undefined) {
      return `${basePath}/${auditId}/ExportInsights`
    } else {
      throw new Error(
        'Either auditId must be provided or isLatest must be true'
      )
    }
  },
  SyncCatalog: (businessProfileId: number, catalogId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/sync`,
  BusinessProfileSettings: (businessProfileId: number) =>
    `businessProfiles/${businessProfileId}/settings`,
  StopLossConfigurations: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/stopLossConfigurations`,
  GetStopLossConfigurationById: (
    businessProfileId: number,
    stopLossConfigurationId: string
  ): string =>
    `businessProfiles/${businessProfileId}/stopLossConfigurations/${stopLossConfigurationId}`,
  StopLossProcessingRuns: (
    businessProfileId: number,
    stopLossConfigurationId: string
  ): string =>
    `businessProfiles/${businessProfileId}/stopLossConfigurations/${stopLossConfigurationId}/stopLossProcessingRuns`,
  StopLossProcessingRunDetails: (
    businessProfileId: number,
    stopLossConfigurationId: string,
    stopLossProcessingRunId: string
  ): string =>
    `businessProfiles/${businessProfileId}/stopLossConfigurations/${stopLossConfigurationId}/stopLossProcessingRuns/${stopLossProcessingRunId}/stopLossProcessingRunDetails`,
  GetStopLossExclusionByProductId: (
    businessProfileId: number,
    productId: number
  ): string =>
    `businessProfiles/${businessProfileId}/Products/${productId}/stopLossExclusions`,
  GetStopLossExclusionByProductVariantId: (
    businessProfileId: number,
    productVariantId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productVariants/${productVariantId}/stopLossExclusions`,
  GetAttributeValuesById: (
    businessProfileId: number,
    catalogId: number,
    parameterId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/productParameters/${parameterId}/attributeValues`,
  getCreativeTemplateById: (
    businessProfileId: number,
    templateId: number
  ): string =>
    `businessProfiles/${businessProfileId}/roimatic/creative-templates/${templateId}`,
  creativeCategory: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/creative-templates/categories`,
  creativeTag: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/creative-templates/tags`,
  creativeTemplates: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/creative-templates/search`,
  publishedCbRenderRequestTemplate: (
    businessProfileId: number,
    templateId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creative-templates/${templateId}/snapshots`,
  publishedRoimaticCreativeVariant: (
    businessProfileId: number,
    creativeSetId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creative-templates/${creativeSetId}/published`,
  getCustomAttributeValues: (businessProfileId: number, catalogId: number) =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/customAttributeValue`,
  createCreativeAutomation: (businessProfileId: number) =>
    `businessProfiles/${businessProfileId}/creativeAutomations/`,
  creativeAutomationById: (businessProfileId: number, id: number) =>
    `businessProfiles/${businessProfileId}/creativeAutomations/${id}`,
  GetCreativeAutomations: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/creativeAutomations`,
  UpdateCreativeAutomation: (businessProfileId: number, id: number) =>
    `/businesses/${businessProfileId}/creativeAutomation/${id}`,
  GetCatalogByCreativeAutomationId: (
    businessProfileId: number,
    creativeAutomationId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creativeAutomations/${creativeAutomationId}/Catalog`,
  GetChannelAttributeValuesById: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/Campaigns`,
  GetValidAttributeValuesCount: (
    businessProfileId: number,
    productCatalogId: number,
    productParameterId: number
  ) =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/productParameters/${productParameterId}/attributeValues/validate`,
  GetEngineFeeds: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productFeeds/live`,
  GetProcessingLogs: (businessProfileId: number, catalogId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/productCatalogProcessingLogs`,
  GetLinkedCatalogs: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/linkedCatalogs`,
  GetFeedEnhancementProducts: (
    businessProfileId: number,
    creativeAutomationId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creativeAutomations/${creativeAutomationId}/feedEnhancementProducts`,
  SyncAutomation: (
    businessProfileId: number,
    creativeAutomationId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creativeAutomations/${creativeAutomationId}/sync`,
  ProcessCatalog: (businessProfileId: number, catalogId: number) =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/process`,
  GetProductParameterValues: (
    businessProfileId: number,
    parameterId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productParameters/${parameterId}/attributeValues`,
  GetValidProductParameterValuesCount: (
    businessProfileId: number,
    productParameterId: number
  ) =>
    `businessProfiles/${businessProfileId}/productParameters/${productParameterId}/attributeValues/validate`,
  SearchFeedEnhancementProducts: (
    businessProfileId: number,
    creativeAutomationId: number
  ): string =>
    `businessProfiles/${businessProfileId}/creativeAutomations/${creativeAutomationId}/feedEnhancementProducts/search`,
  SearchFilteredProductVariants: (
    businessProfileId: number,
    catalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${catalogId}/productVariants/search`,
  getPreviewData: (
    businessProfileId: number,
    cbRenderRequestId: number
  ): string =>
    `businessProfiles/${businessProfileId}/roimatic/creativeBuilderRenderRequests/${cbRenderRequestId}/previewData`,
  ProductImageDetails: (
    businessProfileId: number,
    productCatalogId: number,
    productId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/Products/${productId}/images`,
  ProductVariantImageDetails: (
    businessProfileId: number,
    productCatalogId: number,
    productVariantId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/ProductVariants/${productVariantId}/images`,
  getProductImageTagGroups: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/ProductImageTagGroups`,
  getProductImageTagGroupById: (
    businessProfileId: number,
    tagGroupId: number
  ): string =>
    `businessProfiles/${businessProfileId}/ProductImageTagGroups/${tagGroupId}`,
  getProductImageTagByTagGroupId: (
    businessProfileId: number,
    tagGroupId: number
  ): string =>
    `businessProfiles/${businessProfileId}/ProductImageTagGroups/${tagGroupId}/ProductImageTags`,
  getProductImageTags: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/ProductImageTags`,
  getProductImageTagById: (
    businessProfileId: number,
    tagGroupId: number,
    tagId: number
  ): string =>
    `businessProfiles/${businessProfileId}/ProductImageTagGroups/${tagGroupId}/ProductImageTags/${tagId}`,
  productImages: (
    businessProfileId: number,
    productCatalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/productImages`,
  GetProductAuditIssues: (
    businessProfileId: number,
    catalogId: number
  ): string =>
    `BusinessProfiles/${businessProfileId}/ProductCatalogs/${catalogId}/AuditIssues`,
  applyBackgroundRemove: (
    businessProfileId: number,
    productCatalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/productImages/applyBackgroundRemove`,
  feedEnhancementFiles: (businessProfileId: number): string =>
    `businessProfiles/${businessProfileId}/roimatic/feedEnhancements/files`,
  downloadProcessedImages: (
    businessProfileId: number,
    productCatalogId: number
  ): string =>
    `businessProfiles/${businessProfileId}/productCatalogs/${productCatalogId}/processedImages/download`,
  EngineAuthorizationUrl: (engineId: number | string): string =>
    `engineApiConfiguration/${engineId}/AuthorizationUrl`,
  EngineAccounts: (authKey: string): string =>
    `engineApiConfiguration/${authKey}/Accounts`,
  SearchEngineAuthorization: (businessProfileId: number | string): string =>
    `businessProfiles/${businessProfileId}/SearchEngineAuthorization`,
  ReauthorizeAccount: (
    businessProfileId: number | string,
    businessProfileSearchEngineId: number | string
  ): string =>
    `businessProfiles/${businessProfileId}/channels/${businessProfileSearchEngineId}/reauthorize`
}

export default EndPoints
